import { ButtonHTMLAttributes, ReactNode } from "react";
import { AlertCircle, AlertTriangle, CheckCircle2, Info, X } from "lucide-react";
import styles from "./Alert.module.css";
import { cx } from "../utils";

export interface AlertProps extends ButtonHTMLAttributes<HTMLDivElement> {
    variant: "error" | "warning" | "info" | "success";
    title?: string;
    description: ReactNode;
    icon?: ReactNode;
    dismissible?: boolean;
    onDismiss?: () => void;
    action?: ReactNode;
}

const defaultIcons = {
    error: <AlertCircle size={18} />,
    warning: <AlertTriangle size={18} />,
    info: <Info size={18} />,
    success: <CheckCircle2 size={18} />
};

export const Alert = ({
    variant,
    title,
    description,
    icon,
    dismissible = false,
    onDismiss,
    action,
    className,
    ...props
}: AlertProps) => (
    <div className={cx(styles.alert, styles[variant], className)} role="alert" {...props}>
        <div className={styles.icon}>{icon ?? defaultIcons[variant]}</div>
        <div className={styles.content}>
            {title ? <p className={styles.title}>{title}</p> : null}
            <div className={styles.description}>{description}</div>
        </div>
        {(action || dismissible) && (
            <div className={styles.actions}>
                {action}
                {dismissible ? (
                    <button type="button" className={styles.dismissButton} onClick={onDismiss} aria-label="Dismiss alert">
                        <X size={16} />
                    </button>
                ) : null}
            </div>
        )}
    </div>
);
